import React from "react";
import {useHttp} from "../../../services/HttpService";
import BescheidUebersichtSuche from "./BescheidUebersichtSuche";
import BescheidUebersichtTable from "./BescheidUebersichtTable";
import EABetriebsakteMainContainer from "../../../components/betriebsakte/EABetriebsakteMainContainer";
import {toBase64QueryParam, toQueryString} from "../../../utils/URLUtils";

export default function BescheidUebersichtView(props) {
    const baseUrl = "/betrieb/" + props.betriebsId + "/bescheid/search";

    const [{data, loading}, reload] = useHttp(baseUrl, {manual: false});

    const handleStartSuche = (configuredFilter) => {
        const queryString = toQueryString(configuredFilter);
        const encodedQueryString = toBase64QueryParam(queryString);
        const completeUrl = baseUrl + "?q=" + encodedQueryString;
        reload(completeUrl)
    };

    return (
        <div className={"viewScrollContainer"}>
            <EABetriebsakteMainContainer className={"tabsheet-content-margin"}>
                <BescheidUebersichtSuche onStartSuche={handleStartSuche}/>
                <BescheidUebersichtTable data={data} loading={loading}/>
            </EABetriebsakteMainContainer>
        </div>
    );
}
